<template>
  <div class="detail-page">
    <div class="detail-header">
      <button class="btn-back" @click="goBack">返回</button>
      <h2 class="detail-title">导航详情 - {{ navName }}</h2>
    </div>

    <div class="detail-form">
      <!-- 文章内容编辑 -->
      <div class="form-item">
        <label class="form-label">文章内容：</label>
        <textarea 
          v-model="form.content" 
          class="content-editor" 
          rows="12"
          placeholder="请输入导航对应的文章内容，支持文字介绍"
        ></textarea>
      </div>

      <!-- 详情配图 -->
      <div class="form-item">
        <label class="form-label">详情配图：</label>
        <input ref="contentImgInput" type="file" accept="image/*" @change="handleContentImgChange">
        <img v-if="contentImgPreview" :src="contentImgPreview" class="content-img-preview">
        <p v-else-if="existingImg" class="img-tip">当前已有配图，可重新上传替换</p>
      </div>

      <div class="form-actions">
        <button class="btn-save-detail" @click="saveDetail">保存详情</button>
      </div>
    </div>
  </div>
</template>

<script>
import { getImageUrl } from '@/config.js'
export default {
  name: 'NavDetail',
  data() {
    return {
      navId: '',
      navName: '',
      form: {
        content: '',
        contentImg: null
      },
      contentImgPreview: '',
      existingImg: '',
      rawFile: null
    }
  },
  mounted() {
    // 从路由参数获取导航ID和名称
    this.navId = this.$route.query.id
    this.navName = decodeURIComponent(this.$route.query.name || '')
    this.loadDetail()
  },
  methods: {
    // 加载现有详情
    async loadDetail() {
      const res = await this.$request.post('action.php', `act=getNavDetail&id=${this.navId}`, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      if (res.code === 200 && res.data) {
        this.form.content = res.data.content || ''
        if (res.data.content_img) {
          this.existingImg = getImageUrl(res.data.content_img)
          this.contentImgPreview = this.existingImg
        }
      }
    },

    // 选择详情配图
    handleContentImgChange(e) {
      const file = e.target.files[0]
      if (!file) return
      this.rawFile = file
      const reader = new FileReader()
      reader.onload = (e) => {
        this.contentImgPreview = e.target.result
      }
      reader.readAsDataURL(file)
    },

    // 保存详情
    async saveDetail() {
      if (!this.form.content) {
        alert('请填写文章内容')
        return
      }
      const formData = new FormData()
      formData.append('act', 'saveNavDetail')
      formData.append('id', this.navId)
      formData.append('content', this.form.content)
      if (this.rawFile) {
        formData.append('content_img', this.rawFile)
      }
      const res = await this.$request.post('action.php', formData)
      if (res.code === 200) {
        alert('保存成功')
        this.goBack()
      } else {
        alert(res.msg || '保存失败')
      }
    },

    goBack() {
      this.$router.push('/admin/navManage')
    }
  }
}
</script>

<style scoped>
.detail-page {
  padding: 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 40px);
}
.detail-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
}
.btn-back {
  background: #fff;
  border: 1px solid #dcdfe6;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
}
.detail-title {
  font-size: 20px;
  margin: 0;
  color: #222;
}
.detail-form {
  background: #fff;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
  max-width: 800px;
}
.form-item {
  margin-bottom: 24px;
}
.form-label {
  display: block;
  font-size: 15px;
  color: #444;
  margin-bottom: 8px;
  font-weight: 600;
}
.content-editor {
  width: 100%;
  box-sizing: border-box;
  padding: 12px;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  font-size: 14px;
  resize: vertical;
  line-height: 1.6;
}
.content-editor:focus {
  outline: none;
  border-color: #409eff;
}
.content-img-preview {
  width: 200px;
  margin-top: 10px;
  border-radius: 6px;
  display: block;
}
.img-tip {
  color: #999;
  font-size: 13px;
  margin-top: 8px;
}
.form-actions {
  margin-top: 30px;
}
.btn-save-detail {
  background: #409eff;
  color: #fff;
  border: none;
  padding: 12px 32px;
  border-radius: 6px;
  font-size: 15px;
  cursor: pointer;
}
.btn-save-detail:hover {
  background: #337ecc;
}
.btn-detail {
  background: #e6a23c;
  color: #fff;
  border: none;
  padding: 5px 10px;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 6px;
}
</style>
